export default "__VITE_ASSET__CUoyOmIp__"